import Icon from "../../controls/Icon";
import InputButton from "../../controls/InputButton";
import More from "../../controls/More";
import { Button } from "../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import { log } from "../../util/log";
import { setSafe } from "../../util/storeHelper";
import DNDContainer from "../../views/DNDContainer";
import { addMetaserver, removeMetaserver, setPriorities } from "./actions";
import getText from "./texts";
import * as _ from "lodash";
import * as React from "react";
import { ControlLabel, FormGroup, HelpBlock, ListGroup, ListGroupItem, } from "react-bootstrap";
import { DragSource, DropTarget } from "react-dnd";
import { findDOMNode } from "react-dom";
import { generate as shortid } from "shortid";
import { getErrorMessageOrDefault } from "@vortex/shared";
const serverSource = {
    beginDrag(props) {
        return { id: props.serverId };
    },
    endDrag(props, monitor) {
        if (monitor.getDropResult() === null) {
            return;
        }
        const source = monitor.getItem().id;
        const dest = monitor.getDropResult().id;
        if (source !== dest) {
            props.onDrop();
        }
        else {
            props.onCancel();
        }
    },
};
const serverTarget = {
    hover(props, monitor, component) {
        const source = monitor.getItem().id;
        const target = props.serverId;
        if (source !== target && target !== undefined) {
            const cursorPos = monitor.getClientOffset();
            try {
                const domNode = findDOMNode(component);
                const box = domNode.getBoundingClientRect();
                props.onHover(source, target, cursorPos.y > box.top + box.height / 2);
            }
            catch (err) {
                log("warn", "failed to determine component bounds", {
                    error: getErrorMessageOrDefault(err),
                });
            }
        }
    },
};
function collectDrag(connector, monitor) {
    return {
        connectDragSource: connector.dragSource(),
        isDragging: monitor.isDragging(),
    };
}
function collectDrop(connector, monitor) {
    return {
        connectDropTarget: connector.dropTarget(),
        isOver: monitor.isOver(),
    };
}
/**
 * One row in the meta-server list
 */
class ServerRow extends React.Component {
    render() {
        const { t, connectDragSource, connectDropTarget, isDragging, server } = this.props;
        return connectDropTarget(connectDragSource(React.createElement("div", null,
            React.createElement(ListGroupItem, { active: isDragging, style: { marginLeft: isDragging ? 40 : 0 } },
                server.url,
                React.createElement(Button, { className: "btn-embed pull-right", id: "remove", tooltip: t("Remove"), onClick: this.removeServer },
                    React.createElement(Icon, { name: "remove" }))))));
    }
    removeServer = () => {
        const { serverId, onRemoveMetaserver } = this.props;
        onRemoveMetaserver(serverId);
    };
}
const type = "settings-metaserver-row";
const ServerRowDrag = DropTarget(type, serverTarget, collectDrop)(DragSource(type, serverSource, collectDrag)(ServerRow));
/**
 * list of meta servers
 */
class ServerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderedServers: {},
        };
    }
    componentDidMount() {
        this.pullServerState();
    }
    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.metaservers, this.props.metaservers)) {
            this.pullServerState();
        }
    }
    render() {
        const { t, onAddMetaserver } = this.props;
        const { orderedServers } = this.state;
        const keys = Object.keys(orderedServers);
        const sorted = keys.sort((lhs, rhs) => orderedServers[lhs].priority - orderedServers[rhs].priority);
        return (React.createElement("div", null,
            React.createElement(ListGroup, null,
                sorted.map(this.renderServer),
                React.createElement(ListGroupItem, null,
                    React.createElement(InputButton, { id: "input-add-metaserver", key: "input-add-metaserver", groupId: "settings-buttons", icon: "add", tooltip: t("Add a Metaserver"), onConfirmed: onAddMetaserver })))));
    }
    pullServerState() {
        const { metaservers } = this.props;
        const copy = _.cloneDeep(metaservers);
        Object.keys(copy).forEach((key) => {
            copy[key].priority *= 2;
        });
        this.setState({
            orderedServers: copy,
        });
    }
    renderServer = (serverId) => {
        const { t, onRemoveMetaserver } = this.props;
        const { orderedServers } = this.state;
        return (React.createElement(ServerRowDrag, { t: t, key: serverId, serverId: serverId, server: orderedServers[serverId], onRemoveMetaserver: onRemoveMetaserver, onHover: this.handleHover, onDrop: this.handleDrop, onCancel: this.handleCancel }));
    };
    handleHover = (sourceId, targetId, bottomHalf) => {
        if (sourceId !== targetId && targetId !== undefined) {
            this.setState(setSafe(this.state, ["orderedServers", sourceId, "priority"], this.state.orderedServers[targetId].priority + (bottomHalf ? 1 : -1)));
        }
    };
    handleDrop = () => {
        const { onSetMetaserverPriority } = this.props;
        const { orderedServers } = this.state;
        const sorted = Object.keys(orderedServers).sort((lhs, rhs) => {
            return orderedServers[lhs].priority - orderedServers[rhs].priority;
        });
        onSetMetaserverPriority(sorted);
        this.pullServerState();
    };
    handleCancel = () => {
        this.pullServerState();
    };
}
class SettingsMetaserver extends ComponentEx {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { t, metaservers, onAddMetaserver, onRemoveMetaserver, onSetMetaserverPriority, } = this.props;
        return (React.createElement("form", null,
            React.createElement(FormGroup, null,
                React.createElement(ControlLabel, null,
                    t("Meta Server"),
                    React.createElement(More, { id: "more-metaserver", name: t("Meta Server") }, getText("meta-server", t))),
                React.createElement(DNDContainer, null,
                    React.createElement(ServerList, { t: t, metaservers: metaservers, onAddMetaserver: onAddMetaserver, onRemoveMetaserver: onRemoveMetaserver, onSetMetaserverPriority: onSetMetaserverPriority })),
                React.createElement(HelpBlock, null, t("Servers to query for meta data.")))));
    }
}
function mapStateToProps(state) {
    return {
        metaservers: state.settings.metaserver.servers,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onAddMetaserver: (url) => {
            dispatch(addMetaserver(shortid(), url));
        },
        onRemoveMetaserver: (id) => {
            dispatch(removeMetaserver(id));
        },
        onSetMetaserverPriority: (ids) => {
            dispatch(setPriorities(ids));
        },
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(SettingsMetaserver));
